'use client'

import { useEffect, useState } from 'react'
import { equals } from 'ramda'

import ExpandablePanel from 'shared/ui/ExpandablePanel'
import Checkbox from 'shared/ui/form/Checkbox'

import { FilterDictionary } from '../types'

import {
  DesktopClearButton,
  InputsGroup
} from './styles'

interface TagsFilterMobileProps {
  value: string[] | null
  onChange: (path: string, value: string[] | null) => void
  tags: FilterDictionary[]
}

const TagsFilterMobile = ({ value, onChange, tags }: TagsFilterMobileProps) => {
  const [selectedValue, setSelectedValue] = useState<string[] | null>(null)

  useEffect(() => {
    if (!equals(selectedValue, value)) {
      setSelectedValue(value)
    }
  }, [value])

  const handleSelect = (tagId: string) => () => {
    let currentValues = [...(selectedValue || [])]

    if (currentValues.includes(tagId)) {
      currentValues = currentValues.filter(id => id !== tagId)
    } else {
      currentValues.push(tagId)
    }

    onChange('tag', currentValues.length > 0 ? currentValues : null)
  }

  return (
    <ExpandablePanel title={'Typ produktu'} id='tags-filter-mobile'>
      <InputsGroup>
        <DesktopClearButton />
        {tags?.map(tag => (
          <Checkbox
            key={`mobile-${tag.id}`}
            noMargin
            name={`mobile-${tag.id}`}
            onChange={handleSelect(tag.id)}
            value={selectedValue?.includes(tag.id) || false}
            label={tag.name}
          />
        ))}
      </InputsGroup>
    </ExpandablePanel>
  )
}

export default TagsFilterMobile
